import React from "react";
import { Phone } from "lucide-react";
import { CONTACT } from "../mock";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor">
    <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.117.555 4.184 1.61 6.004L4 29l8.184-1.57a11.94 11.94 0 0 0 3.82.629h.004C22.625 28.059 28 22.676 28 16.055 28 12.84 26.75 9.82 24.48 7.55A11.86 11.86 0 0 0 16.004 3zm0 2.184c2.86 0 5.547 1.114 7.57 3.137a10.66 10.66 0 0 1 3.14 7.57c0 5.906-4.804 10.71-10.71 10.71h-.004a9.9 9.9 0 0 1-3.36-.586l-.24-.09-4.86.933.93-4.734-.16-.25a9.87 9.87 0 0 1-1.52-5.27c0-5.906 4.807-10.71 10.71-10.71zm-5.86 6.02c-.196 0-.516.074-.786.36-.27.293-1.03 1.008-1.03 2.457s1.055 2.85 1.203 3.047c.148.195 2.078 3.172 5.04 4.45.703.304 1.25.484 1.68.62.703.223 1.343.192 1.85.117.563-.086 1.734-.71 1.98-1.394.246-.684.246-1.27.172-1.394-.074-.125-.27-.196-.563-.343-.293-.148-1.734-.856-2.004-.953-.27-.098-.465-.148-.66.148-.196.293-.758.953-.93 1.148-.172.196-.343.223-.636.075-.293-.148-1.238-.457-2.36-1.457-.872-.777-1.46-1.738-1.632-2.031-.172-.293-.018-.451.129-.598.132-.132.293-.343.44-.515.147-.172.196-.293.293-.489.098-.195.05-.366-.024-.514-.074-.148-.66-1.594-.906-2.18-.238-.57-.48-.492-.66-.5-.172-.008-.367-.01-.563-.01z" />
  </svg>
);

const FloatingButtons = () => {
  const msg = encodeURIComponent(
    "Hi, I'm interested in the Hyderabad to Srisailam tour package. Please share the details."
  );
  return (
    <div className="fixed z-50 right-4 bottom-4 flex flex-col gap-3">
      <a
        href={`https://wa.me/${CONTACT.whatsapp}?text=${msg}`}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative h-14 w-14 rounded-full bg-[#25D366] shadow-xl flex items-center justify-center text-white hover:scale-110 transition-transform"
        aria-label="WhatsApp"
      >
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" />
        <WhatsAppIcon className="relative h-8 w-8" />
      </a>
      <a
        href={`tel:+91${CONTACT.primary}`}
        className="group relative h-14 w-14 rounded-full bg-orange-600 shadow-xl flex items-center justify-center text-white hover:scale-110 transition-transform"
        aria-label="Call"
      >
        <span className="absolute inline-flex h-full w-full rounded-full bg-orange-600 opacity-60 animate-ping" />
        <Phone className="relative h-6 w-6" />
      </a>
    </div>
  );
};

export default FloatingButtons;
